import './styles.css';

export default function ButtonSecondary({ 
    children, 
    onClick, 
    disabled = false, 
    icon, 
    className = "",
    type = "button"
}) {
    return (
        <button
            type={type}
            onClick={onClick}
            disabled={disabled}
            className={`button-secondary ${disabled ? 'disabled' : ''} ${className}`}
        >
            {icon && <span className="button-icon">{icon}</span>}
            <span className="button-text">{children}</span>
        </button>
    );
}
